import angular from 'angular';

export default angular.module('autoboard.backdropRow', [])
  .directive('bdRow', function () {
    'ngInject';

    return {
      restrict: 'E',
      transclude: true,
      scope: {
        show: '='
      },
      templateUrl: require('./bd-row.template.html')
    }
  })
  .name;